import * as React from "react";

import { t } from "@impero-com/common/utils/i18n";
import { assertNever } from "@impero-com/common/utils/obj";
import { Moment } from "moment-timezone";

import { MultiDatePicker } from "components/form/legacyFields/multiDatePicker";

// For Date(Manual) controls we use wording "Due Date", while for the other types of controls we use wording "Starting From"
type StartDateLabelType = "StartDate" | "OnceDate";

interface StartingFromDatePickerProps {
    readOnly: "EDIT" | "READ_ONLY";
    values: Moment[];
    onChange?: (v: Moment) => void;
    labelType: StartDateLabelType;
    className?: string;
}

class StartingFromDatePicker extends React.PureComponent<StartingFromDatePickerProps> {
    render = (): React.ReactNode => {
        const { readOnly, values, onChange, labelType, className } = this.props;
        const normalOnChange = (val: Moment | null | undefined) => {
            if (onChange && val) {
                onChange(val);
            }
        };
        const label = translateLabel(labelType);
        switch (readOnly) {
            case "EDIT":
                return (
                    <MultiDatePicker
                        type="EDIT"
                        name="startingFromDate"
                        label={label}
                        onChange={normalOnChange}
                        values={values}
                        allowClear={false}
                        className={className}
                    />
                );
            case "READ_ONLY":
                return (
                    <MultiDatePicker
                        type="READ_ONLY"
                        name="startingFromDate"
                        label={label}
                        values={values}
                        className={className}
                    />
                );
            default:
                assertNever(readOnly);
        }
    };
}

function translateLabel(labelType: StartDateLabelType): string {
    switch (labelType) {
        case "StartDate":
            return t("CreateControl_Recurrence_Interval_StartDate");
        case "OnceDate":
            return t("CreateControl_Recurrence_Once_Date");
        default:
            return assertNever(labelType);
    }
}
export type { StartDateLabelType, StartingFromDatePickerProps };
export { StartingFromDatePicker, translateLabel };
